const o = "8.50.0";
export {
  o as SDK_VERSION
};
